import React, { Component } from 'react'

export class BrandItem extends Component {
   render() {
      return (
         <div className='brand_icons--items'>
            <img src={"./img/brandsico/" + this.props.item.icons} />
         </div>
      )
   }
}

export default BrandItem

